import { SITE, whatsappUrl } from "@/config/site";
import { AccessLink } from "@/components/AccessLink";
import { IconByName } from "@/components/icons";
import { cn } from "@/lib/utils";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  const socials = [
    { id: "instagram", label: "Instagram", icon: "Instagram", href: SITE.links.instagram },
    { id: "whatsapp", label: "WhatsApp", icon: "WhatsApp", href: whatsappUrl() },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#05070b]">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center md:justify-between">
        <div>
          {SITE.logoSrc && (
            <img
              src={SITE.logoSrc}
              alt="Logo FW Team Fitness"
              className="h-14 w-14 rounded-xl object-cover"
            />
          )}
          <p className="mt-3 text-sm text-slate-400">
            {SITE.trainerName} — {SITE.cref}
          </p>
          <p className="mt-1.5 font-mono text-xs uppercase tracking-[0.2em] text-brand-blue/70">
            {SITE.slogan}
          </p>
        </div>

        <div className="flex items-center gap-3" data-testid="footer-social-links">
          {socials.map((social) => (
            <AccessLink
              key={social.id}
              href={social.href}
              external
              showBadge={false}
              testId={`footer-social-${social.id}`}
              ariaLabel={`${social.label} da FW Team Fitness${social.href ? "" : " (em breve)"}`}
              className={cn(
                "relative flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-slate-300 transition-all hover:border-brand-teal/50 hover:text-brand-blue active:scale-95 aria-disabled:opacity-40",
                !social.href && "cursor-not-allowed",
              )}
            >
              <IconByName name={social.icon} className="h-5 w-5" />
              {!social.href && <span className="sr-only">Em breve</span>}
            </AccessLink>
          ))}
        </div>
      </div>

      <div className="border-t border-white/5 py-5 text-center text-xs text-slate-500">
        © {year} FW Team Fitness. Todos os direitos reservados.
      </div>
      <div className="h-16 md:h-10" aria-hidden="true" />
    </footer>
  );
}
